class ZenCheckDelivery extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.zen-check-delivery__input');
    this.button = this.querySelector('.zen-check-delivery__locate-btn');
    this.banner = this.querySelector('.zen-check-delivery__banner');
    this.deliveryText = this.querySelector('.zen-check-delivery__delivery-text');

    this.button.addEventListener('click', this.handleLocate.bind(this));
    this.input.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleLocate);
    this.input?.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.handleLocate();
    }
  }

  handleLocate() {
    const pincode = this.input.value.trim();

    if (!pincode || pincode.length < 5) {
      this.banner.classList.remove('is-visible');
      this.input.focus();
      return;
    }

    const prefix = this.dataset.deliveryPrefix ?? 'Free Delivery by';
    const days = parseInt(this.dataset.deliveryDays, 10) || 7;
    const dateStr = this.getDeliveryDate(days);

    this.deliveryText.textContent = `${prefix} ${dateStr}`;
    this.banner.classList.add('is-visible');
  }

  getDeliveryDate(days) {
    const date = new Date();
    date.setDate(date.getDate() + days);

    const day = date.getDate();
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = MONTHS[date.getMonth()];

    return `${day}${this.getOrdinalSuffix(day)} ${month}`;
  }

  getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
}

if (!customElements.get('zen-check-delivery')) {
  customElements.define('zen-check-delivery', ZenCheckDelivery);
}
